<template>
	<div class="cmo">
		<div class="cmo_content">
			<div class="cmo_content_title">CMO/CDMO业务</div>
			<!-- 使用抽取的组件 -->
			<RichTextWithImages
				v-if="configData?.cdmd_desc?.length > 0"
				:content="configData?.cdmd_desc[0]"
				:enable-image-preview="true"
				:max-image-width="'100%'"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import carousel from '@/components/carousel.vue'
	import RichTextWithImages from '@/components/RichTextWithImages.vue'
  	import { useConfigStore } from "@/stores/index.ts";
	// 获取配置
	const store = useConfigStore()
	const configData = computed(() => {
		console.log(store.configData,"store.configData")
		return store.configData
	})

</script>

<style lang="styl" scoped>
.cmo{
	width 100%
	min-height calc(100% - 70px - 200px)
	background-color #fff
	min-width 1200px
	.carousel{
		margin-bottom 130px
	}
	.cmo_content{
		width 100%
		height 100%
		padding 70px 200px 100px 200px
		.cmo_content_title{
			font-weight: 500;
			font-size: 23px;
			color: #252525;
			line-height: 23px;
			text-align: center;
			margin-bottom 30px
		}
	}
	@media (max-width: 1400px) {
      .cmo_content {
        padding: 70px 100px 100px 100px;
      }
    }
}
</style>